import { Navigate, useRoutes } from 'react-router-dom'
import { _bootstrap }                  from 'state/store.bootstrap'
import { useAtom, useFocusGet }                 from 'state/jotai'

import { Root }                                     from 'pages/View.Root'
import { standard } from 'pages/Views.constants'

import { current_language } from 'state/store.global'

export const useBuildRoutes = () => {

  const language = useAtom(current_language)[0];
  const start    = useFocusGet(_bootstrap, 'startpage')
      
  return [
        {
          path: '/',
          element: <Root />,
          children: [
            { path: '', element: <Navigate to={start} replace />, index: true },
            ... standard(language,start),
            { path: '*', element: <Navigate to={start} replace />, index: true  },
          ],
        },
      ]
}

export const Views = () => useRoutes( useBuildRoutes() )